var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomIkon = function SvgZoomIkon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "zoom_ikon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .273h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#zoom_ikon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.164 12.077c-1.277 0-2.364-.448-3.26-1.344-.895-.896-1.343-1.983-1.343-3.26 0-1.276.448-2.363 1.343-3.259.896-.896 1.983-1.344 3.26-1.344 1.277 0 2.363.448 3.259 1.344.896.896 1.344 1.983 1.344 3.26 0 .51-.075.988-.226 1.43a4.67 4.67 0 0 1-.62 1.219l3.977 3.98a.757.757 0 0 1 .238.543c0 .2-.081.38-.242.539a.755.755 0 0 1-1.1 0L9.822 11.23c-.372.263-.781.47-1.227.62a4.45 4.45 0 0 1-1.43.226Zm0-1.557c.848 0 1.568-.295 2.16-.887.59-.592.886-1.311.886-2.16 0-.848-.295-1.568-.887-2.16-.591-.59-1.311-.886-2.16-.886-.847 0-1.567.295-2.159.887-.591.591-.887 1.311-.887 2.16 0 .848.296 1.567.887 2.159.592.592 1.312.887 2.16.887Z",
    fill: "#fff"
  }))));
};
export default SvgZoomIkon;